import * as React from 'react';
import Config from '../../Config';
import PortalIntegration from '../../PortalIntegration';
import Error from '../Error/Error';

interface RedirectToPortalPageProps {
    embedUrl: string;
}

export default class RedirectToPortalPage extends React.Component<RedirectToPortalPageProps, undefined> {

    private _iframe: HTMLIFrameElement;

    componentDidMount() {

        var baseUrl = Config.getWebPortalBaseUrl();
        var isSafeUrl = (this.props.embedUrl.indexOf(baseUrl) == 0);

        if (isSafeUrl) {

            var redirectUrl = this.props.embedUrl;

            if (redirectUrl.indexOf('?') == -1) {
                redirectUrl = redirectUrl + "?embeddedUserAgent=" + encodeURIComponent(PortalIntegration.getUserAgentString());
            }
            else {
                redirectUrl = redirectUrl + "&embeddedUserAgent=" + encodeURIComponent(PortalIntegration.getUserAgentString());
            }

            window.location.href = redirectUrl;
        }
        else {
            console.error("Invalid embed URL.");
        }
    }

    render() {
        return <div></div>;
    }

}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/tasks/RedirectToPortalPage/RedirectToPortalPage.tsx